import { render, staticRenderFns } from "./weekdays.vue?vue&type=template&id=22c1c5b6&scoped=true"
import script from "./weekdays.vue?vue&type=script&lang=js"
export * from "./weekdays.vue?vue&type=script&lang=js"
import style0 from "./weekdays.vue?vue&type=style&index=0&id=22c1c5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1c5b6",
  null
  
)

export default component.exports